import Alpine from 'alpinejs';

// Alpine.jsを有効化
window.Alpine = Alpine;
Alpine.start();

// jQueryを有効化、バリデーションを設定
import $ from 'jquery';
import 'jquery-validation';

$(function() {
  $("#form").validate({
    rules: {
      your_name: {
        required: true
      },
      your_type: {
        required: true
      },
      'your_service[]': {
        required: true
      },
      your_zipcode: {
        required: true
      },
      your_address: {
        required: true
      },
      your_tel: {
        required: true
      },
      your_email: {
        required: true
      },
      your_content: {
        required: true
      },
    },
    messages: {
      your_name: {
        required: "！お名前を入力ください"
      },
      your_type: {
        required: "！属性を選択ください"
      },
      'your_service[]': {
        required: "！サービスを選択ください"
      },
      your_zipcode: {
        required: "！住所を入力ください"
      },
      your_address: {
        required: "！住所を入力ください"
      },
      your_tel: {
        required: "！電話番号を入力ください"
      },
      your_email: {
        required: "！メールアドレスを入力ください"
      },
      your_content: {
        required: "！お問い合わせ内容を入力ください"
      },
    },
    errorPlacement: function(error, element) {
      // チェックボックスの場合
      if (element.is(':checkbox')) {
        // 同じnameを持つ全てのチェックボックスにerrorクラスを追加
        $('input:checkbox[name="' + element.attr('name') + '"]').addClass('error');
        // エラーメッセージの配置（例：最後のチェックボックスの後）
        error.insertAfter($('input:checkbox[name="' + element.attr('name') + '"]').last());
      } else {
        // 他の要素タイプの場合は通常の動作
        error.insertAfter(element);
      }

      // data-input-name属性に指定された値を取得
      const id = element.attr("data-input-name");
      $("#" + id + "_error").html(error);
    },
    highlight: function(element, errorClass) {
      if ($(element).is(':checkbox')) {
        // 同じnameを持つ全てのチェックボックスにerrorクラスを追加
        $('input:checkbox[name="' + $(element).attr('name') + '"]').addClass(errorClass);
      } else {
        $(element).addClass(errorClass);
      }
    },
    unhighlight: function(element, errorClass) {
      if ($(element).is(':checkbox')) {
        // 同じnameを持つ全てのチェックボックスからerrorクラスを削除
        $('input:checkbox[name="' + $(element).attr('name') + '"]').removeClass(errorClass);
      } else {
        $(element).removeClass(errorClass);
      }
    },
    submitHandler: function(form) {
      // #formのdata-recapcha-tokenのvalueを取得
      const recapchaToken = $('#form_submit').data('recapcha-token');
      console.log(recapchaToken);
      
      grecaptcha.ready(function () {
        grecaptcha.execute(recapchaToken, {action: "submit"}).then(function(token) {
          //reCAPTCHAで発行されたトークンが変数tokenに格納されている
          document.getElementById("recaptchaResponse").value = token;
          document.getElementById('form').submit();
        });
      });
      return false;
    },
  });
});
